import styled, { css } from 'styled-components'

import { device } from '~/styles/device'

export const Header = styled.header`
  .alertBrands {
    margin-bottom: 0.5rem;
  }
`

export const BulkSection = styled.section`
  textarea {
    height: 20rem;
    max-height: 40vh;
  }

  .alertsForm {
    margin-bottom: 0.5rem;
  }
`

/**
 * List
 */

export const ProductsLists = styled.div`
  ${({ theme }) => css`
    @media ${device.laptop} {
      display: grid;

      grid-template-columns: repeat(2, minmax(320px, 1fr));

      min-height: calc(50vh - 20px);
      max-height: calc(90vh - 100px);
    }

    @media ${device.laptop_max} {
      display: flex;
      flex-direction: column;
    }
  `}
`

export const ProductsList = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;

    z-index: 5;
    position: relative;
    overflow-y: auto;

    min-height: calc(50vh - 20px);
    max-height: calc(90vh - 100px);

    .empty {
      background: ${theme.colors.light};
      border-radius: 1rem;
      width: 100%;
      min-height: 40vh;
      padding: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /* Space to scrollbar */

    &:first-child {
      @media ${device.laptop} {
        padding-right: 1rem;
      }

      @media ${device.laptop_max} {
        max-height: 75vh;
      }
    }

    &:last-child {
      @media ${device.laptop_max} {
        max-height: unset;
        min-height: unset;
      }

      @media ${device.laptop} {
        padding-right: 0.5rem;
        padding-left: 1rem;
        border-left: 1px solid ${theme.colors.tertiary};
      }
    }

    /* width */
    ::-webkit-scrollbar {
      width: 0.5rem;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${theme.colors.inative};
      border-radius: 0.5rem;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.tertiary};
      transition: 0.3s ease-in-out all;
      border-radius: 0.5rem;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${theme.colors.gray};
    }

    > div + div {
      margin-top: ${theme.spacings.xsmall};
    }
  `}
`

export const ProductsListHeader = styled.header`
  ${({ theme }) => css`
    z-index: 10;
    position: sticky;
    top: 0;
    padding: 0 0 ${theme.spacings.xsmall} 0;
    background: ${theme.colors.white};

    .alertWrapper {
      margin: 0;
      margin-top: ${theme.spacings.xsmall};
    }
  `}
`

export const Heading = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Title = styled.h4`
  ${({ theme }) => css`
    margin-bottom: 0;
    line-height: 1;
    font-size: 0.875rem;

    span {
      font-size: 0.875rem;
      color: ${theme.colors.neutral.low.medium};
    }
  `}
`

export const Info = styled.div`
  ${({ theme }) => css`
    border-radius: 0.25rem;
    padding: 0.5rem;
    background: rgba(170, 166, 221, 0.15);
    border-left: 0.125rem solid ${theme.colors.primary};

    > div {
      color: ${theme.colors.primary};
      font-size: 0.875rem;
      font-weight: 600;

      > svg {
        fill: ${theme.colors.primary};
        color: ${theme.colors.white};
        width: 1.313rem;
        height: 1.313rem;
      }
    }
  `}
`
